module.exports = __webpack_public_path__ + "media/images/gifts/care/sug_cuidar_6-aa2e57c23afaf430dcbd06cad5d6cce3.jpg";